import { ArrowRight } from "lucide-react";
import { Reveal, SectionHead } from "../components/Reveal";
import { HANDSHAKE_IMAGE } from "../data/content";
import { scrollToId } from "../lib/scroll";

const CONTEXTS = [
    "Investimentos",
    "Contratos empresariais",
    "Operações societárias",
    "Patrimônio e negócios complexos",
];

export const Planning = () => (
    <section id="planejamento" data-testid="planning-section" className="bg-cream-dark py-24 sm:py-32">
        <div className="mx-auto grid max-w-7xl items-center gap-16 px-5 sm:px-8 lg:grid-cols-12">
            <div className="relative lg:col-span-5">
                <Reveal>
                    <div className="relative overflow-hidden rounded-sm border border-cream-line">
                        <img
                            src={HANDSHAKE_IMAGE.url}
                            alt={HANDSHAKE_IMAGE.alt}
                            className="h-[440px] w-full object-cover"
                            loading="lazy"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-ink/50 via-transparent to-transparent" />
                        <div className="absolute bottom-5 left-5">
                            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-cream/80">
                                Antes do conflito
                            </p>
                            <p className="mt-1 font-serif text-xl text-cream">
                                Planejar é reduzir incertezas
                            </p>
                        </div>
                    </div>
                </Reveal>
            </div>

            <div className="lg:col-span-7">
                <SectionHead
                    eyebrow="Planejamento jurídico"
                    title="Arbitragem como instrumento de planejamento jurídico"
                />
                <Reveal delay={0.1} className="mt-8 space-y-6 text-base leading-relaxed text-graphite-text">
                    <p>
                        A arbitragem não precisa ser considerada apenas quando o conflito já existe.
                        Sua previsão em contratos pode fazer parte de uma estratégia de planejamento
                        jurídico, permitindo que as partes estabeleçam antecipadamente um mecanismo
                        para lidar com eventuais controvérsias.
                    </p>
                    <p>
                        Em relações empresariais que envolvem investimentos, contratos, operações
                        societárias, patrimônio e negócios de maior complexidade, estabelecer
                        previamente a forma de resolução de conflitos contribui para reduzir
                        incertezas e proporcionar maior segurança às relações.
                    </p>
                </Reveal>
                <Reveal delay={0.18} className="mt-8 flex flex-wrap gap-2.5">
                    {CONTEXTS.map((c) => (
                        <span
                            key={c}
                            className="border border-cream-line bg-white px-4 py-2 text-xs font-medium uppercase tracking-[0.12em] text-graphite-text"
                        >
                            {c}
                        </span>
                    ))}
                </Reveal>
                <Reveal delay={0.24}>
                    <button
                        type="button"
                        data-testid="planning-clause-link"
                        onClick={() => scrollToId("#clausula")}
                        className="group mt-10 inline-flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.16em] text-gold-dark transition-colors hover:text-ink"
                    >
                        Ver esboço de cláusula compromissória
                        <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1.5" />
                    </button>
                </Reveal>
            </div>
        </div>
    </section>
);
